import { useEffect, useState } from "react";

const KEY = "anatradex-lang";

export function getPublicLang() {
  const stored = localStorage.getItem(KEY);
  if (stored === "fr" || stored === "en") return stored;
  return (navigator.language || "fr").toLowerCase().startsWith("fr") ? "fr" : "en";
}

export function usePublicLang() {
  const [lang, setLangState] = useState(getPublicLang);
  useEffect(() => {
    const onChange = () => setLangState(getPublicLang());
    window.addEventListener("anatradex-lang-change", onChange);
    return () => window.removeEventListener("anatradex-lang-change", onChange);
  }, []);
  const setLang = (l) => {
    localStorage.setItem(KEY, l);
    setLangState(l);
    window.dispatchEvent(new Event("anatradex-lang-change"));
  };
  return [lang, setLang];
}

export function LangToggle({ lang, setLang }) {
  return (
    <button
      onClick={() => setLang(lang === "fr" ? "en" : "fr")}
      className="text-xs font-semibold border border-white/20 rounded-full px-2.5 py-1 text-white/70 hover:text-white hover:border-white/40 transition"
      data-testid="lang-toggle"
    >
      {lang === "fr" ? "EN" : "FR"}
    </button>
  );
}
